// Libraries
import React, { useState } from 'react'
import * as yup from 'yup'

// Hooks
import { useForm } from 'react-hook-form'

// Components
import { yupResolver } from '@hookform/resolvers/yup'

// Layouts
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'
import Progress from '../../components/Progress'
import { TextDescription, WrapFormContent } from '../StageOne/WrapFormContent'
import { Input } from '../../ui/Input/index'
import { Button } from '../../ui/Button'
import { ArrowLeft, TextButton } from '../../ui/TextButton'
import { AxiosError } from 'axios'
import { WrapInput } from '../../ui/Input/style'

interface IProps {
  setStageAndToTop: (arg0: number) => void;
  appendData: (arg0: object) => void;
  currentStage: number;
  data: object;
  toast: any;
}

interface IFormInputs {
  phone: string;
}

const SignupSchema = yup
  .object({
    phone: yup.string().required('Dieses Feld ist erforderlich').matches(/^\+[1-9]\d{1,14}$/, 'Geben Sie eine gültige Telefonnummer ein'),
  })
  .required();

export const StageFour = ({ currentStage, setStageAndToTop, appendData, data, toast }: IProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const axios = require('axios').default;

  const { register: phoneRegister, handleSubmit: phoneHandleSubmit, reset: phoneReset, formState: { errors } } = useForm<IFormInputs>({
    resolver: yupResolver(SignupSchema)
  })

  const onPhoneHandleSubmit = async (body: object) => {
    appendData(body)
    phoneReset()
    setIsLoading(true)

    type IResponse = {
      message: string;
      code: string;
    }

    await axios.post('https://dev.charter-it.com:37153/api/newsletterservice/new/user/create', data, { headers: {
        'Access-Control-Allow-Origin': 'true'
      }})
      .then((response: any): object => {
        toast({
          title: response.message,
          description: response?.code,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
        })
        setStageAndToTop(5)
        return response
      })
      .catch((error: AxiosError<IResponse>): object => {
        toast({
          title: error.message,
          description: error?.code,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
        })
        setStageAndToTop(0)
        return error
      })
      .then(() => setIsLoading(false))
  }

  return (
    <>
      <MainWrapperWithCaptions stage={currentStage}
                               title={<>Du hast es nahezu <br /> geschafft</>}
                               key={4}
                               textAlign='left'>
        <Progress stage={currentStage} />
      </MainWrapperWithCaptions>
      <WrapFormContent onSubmit={phoneHandleSubmit(onPhoneHandleSubmit)}>
        <WrapInput>
          <Input autoFocus placeholder='Telefonnummer* (z.B. +4930901820)' disabled={isLoading} {...phoneRegister('phone')} errorMessage={errors?.phone?.message}  isError={errors?.phone !== undefined} />
        </WrapInput>
        <TextDescription>*Morbi sed bibendum ut commodo lorem. Viverra malesuada sit sed ut amet quam mi.</TextDescription>
        <Button arrow>{isLoading ? 'Loading..' : 'Weiter'}</Button>
        <TextButton onClick={() => setStageAndToTop(3)}>
          <ArrowLeft width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L0.999999 10.5L9 20" stroke="white" strokeWidth="1.5"/>
          </ArrowLeft>
          Zurück
        </TextButton>
      </WrapFormContent>
    </>
  )
}